import Notfound from "pages/notFound/NotFound";
import { lazy } from "react";

class AppPages {
  static PageKeys: Record<string, React.LazyExoticComponent<React.FC<any>>> = {
    GeneralFeature: lazy(() => import("pages/generals/views/GeneralFeature")),
    TransactionFeature: lazy(
      () => import("pages/transactionHistory/views/TransactionFeature")
    ),
    BalanceHistoryFeature: lazy(
      () => import("pages/balanceHistory/view/BalanceHistoryFeature")
    ),
    TopupManagementFeature: lazy(
      () => import("pages/topUpPackagesManagement/views/TopupManagementFeature")
    ),
    TopUpForTravelServiceFeature: lazy(
      () =>
        import(
          "pages/topUpPackagesManagement/views/topUpForTravelServiceViews/TopUpForTravelServiceFeature"
        )
    ),
    TopUpForPackageFeature: lazy(
      () =>
        import(
          "pages/topUpPackagesManagement/views/topUpForPackageViews/TopUpForPackageFeature"
        )
    ),
    ContentManagementFeature: lazy(
      () => import("pages/contentManagement/views/ContentManagementFeature")
    ),
    RoamingManagementFeature: lazy(
      () => import("pages/roamingManagement/views/RoamingManagementFeature")
    ),
    UserManagementFeature: lazy(
      () => import("pages/usersManagement/views/UserManagementFeature")
    ),
    AddressManagementFeature: lazy(
      () => import("pages/addressManagement/views/AddressManagementFeature")
    ),
    ChangePasswordFeature: lazy(
      () => import("pages/changePassword/views/ChangePasswordFeature")
    ),
    PathConfigMangementFeature: lazy(
      () =>
        import("pages/pathConfigManagement/views/PathConfigMangementFeature")
    ),
    CountryManagementFeature: lazy(
      () => import("pages/countryManagement/views/CountryManagementFeature")
    ),
    FileManagementFeature: lazy(
      () => import("pages/fileManagement/views/FileManagementFeature")
    ),
    PackagesRegistrationFeature: lazy(
      () =>
        import("pages/packagesRegistration/views/PackagesRegistrationFeature")
    ),
    RoamingPartnerManagementFeature: lazy(
      () =>
        import(
          "pages/roamingPartnerManagement/views/RoamingPartnerManagementFeature"
        )
    ),
    AppProfileRegisterFeature: lazy(
      () => import("pages/appProfileRegister/view/AppProfileRegisterView")
    ),
    AppPhoneRechargeFeature: lazy(
      () => import("pages/appPhoneRecharge/view/AppPhoneRechargeView")
    ),
    AppAddBalanceRechargeFeature: lazy(
      () => import("pages/appAddBalanceRecharge/view/AppAddBalanceRechargeView")
    ),
    AppFeedbackFeature: lazy(
      () => import("pages/appFeedback/view/AppFeedbackView")
    ),
    AppSimMobifoneFeature: lazy(
      () => import("pages/appSimMobifone/view/AppSimMobifoneView")
    ),
    AppDataRegisterFeature: lazy(
      () => import("pages/appDataRegister/view/AppDataRegisterView")
    ),
    AppNiceSimFeature: lazy(
      () => import("pages/appNiceSim/view/AppNiceSimView")
    ),
    AppTravelSimFeature: lazy(
      () => import("pages/appTravelSim/view/AppTravelSimView")
    ),
    UserAppManagementFeature: lazy(
      () => import("pages/userAppManagement/view/UserAppManagementView")
    ),

    UserTravelSimManagementFeature: lazy(
      () =>
        import(
          "pages/travelSimProfileRegister/view/TravelSimProfileRegisterView"
        )
    ),
    PaymentMethodManagementFeature: lazy(
      () =>
        import(
          "pages/paymentMethodManagement/views/PaymentMethodManagementFeature"
        )
    ),
    SupplierManagementFeature: lazy(
      () => import("pages/supplierManagement/views/SupplierManagementFeature")
    ),
    AirTimeManagementFeature: lazy(
      () => import("pages/airTimeManagement/views/AirTimeManagementFeature")
    ),
    DiscountManagementFeature: lazy(
      () => import("pages/discountManagement/views/DiscountManagementFeature")
    ),
    SimManagementFeature: lazy(
      () => import("pages/simManagement/view/SimManagementFeature")
    ),
  };

  static getPage(key: string): any {
    return this.PageKeys[key] || Notfound;
  }
}

export default AppPages;
